import { Message } from 'iview'
import { api } from '@/services'
const FETCH_LIST_REQUEST = 'FETCH_LIST_REQUEST'
const FETCH_LIST_FAILURE = 'FETCH_LIST_FAILURE'
const FETCH_LIST_SUCCESS = 'FETCH_LIST_SUCCESS'
export const state = {
  fetching: false,
  personInfoList: [],
  pagination: {
    total: 0,
    pageIndex: 1,
    pageSize: 15,
  }
}
export const getters = {
  personInfoList: state => state.personInfoList,
  pagination: state => state.pagination
}

export const mutations = {
  setPagination (state, params) {
    state.pagination = params
  },
  [FETCH_LIST_REQUEST]: state => (state.fetching = true),
  [FETCH_LIST_FAILURE]: state => (state.fetching = false),
  [FETCH_LIST_SUCCESS]: (state, { data, pagination }) => {
    state.fetching = false
    state.perList = data
    if (pagination.pageIndex == 1) {
      state.personInfoList = data.list
    } else {
      state.personInfoList.push(...data.list)
    }
    state.pagination = {
      ...state.pagination,
      ...pagination
    }
    state.pagination.total = data.total
  }
}

export const actions = {
  async getDoctorInitiateTreatmentList ({ commit, state }, params = {}) {
    if (state.fetching) {
      // state.fetching = false
      return Message.loading('请稍等，正在获取列表...')
    }
    commit(FETCH_LIST_REQUEST)
    const pagination = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize
    }
    if (params.pageIndex === undefined) {
      pagination.pageIndex = ~~state.pagination.pageIndex + 1
    }
    if (params.pageSize === undefined) {
      pagination.pageSize = state.pagination.pageSize
    }
    const { success, data } = await api
      .getDoctorInitiateTreatmentList({
        data: { params: Object.assign({}, params, pagination) }
      })
      .catch(err => (commit(FETCH_LIST_FAILURE, err)))
    if (success) {
      commit(FETCH_LIST_SUCCESS, { data, pagination })
    } else {
      commit(FETCH_LIST_FAILURE)
    }
    return { success }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/InitiateTreatment.js